// Angular
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-logged-out-page-wrapper',
    templateUrl: './logged-out-page-wrapper.component.html',
    styleUrls: ['./logged-out-page-wrapper.component.scss'],
    standalone: false
})
export class LoggedOutPageWrapperComponent implements OnInit {
    lang: 'nl' | 'fr' = 'nl';

    constructor(private route: ActivatedRoute){}

    ngOnInit(){
        if (this.route?.snapshot?.params?.language_code) {
            this.lang = this.route.snapshot.params.language_code;
        }
    }
}
